import React from 'react';
import './ChildGrid.css';

const ChildGrid = ({ children }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
      {children.map((child,index) => (
        <div key={index} className="grid-item">
          {child.nombre}
        </div>
      ))}
    </div>
  );
};

export default ChildGrid;
